import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { t } from '../../i18n/translate.js';
import colors from '../../styles/export.module.scss.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import Icon from '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import useTestMagnet, { state } from './useTestMagnet.js';
import styles from './TestMagnetComponent.module.scss.js';

var TestMagnetComponent = function TestMagnetComponent(_ref) {
  var giid = _ref.giid,
    deviceLabel = _ref.deviceLabel,
    onMagnetStateChanged = _ref.onMagnetStateChanged,
    client = _ref.client,
    onTestStateChanged = _ref.onTestStateChanged,
    intervalInMillis = _ref.intervalInMillis,
    useTestMagnetFunc = _ref.useTestMagnetFunc;
  var _useTestMagnetFunc = useTestMagnetFunc(client, giid, deviceLabel, intervalInMillis),
    magnetState = _useTestMagnetFunc.magnetState,
    testState = _useTestMagnetFunc.testState,
    startTest = _useTestMagnetFunc.startTest;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    notification = _useState2[0],
    setNotification = _useState2[1];
  useEffect(function () {
    onMagnetStateChanged(magnetState);
  }, [magnetState]);
  useEffect(function () {
    onTestStateChanged(testState);
  }, [testState]);
  useEffect(function () {
    if (giid && deviceLabel) {
      startTest();
    }
  }, [giid, deviceLabel]);
  useEffect(function () {
    if (magnetState) {
      if (testState === state.NOT_STARTED) {
        if (magnetState === 'UNKNOWN') {
          setNotification(t('MPLIB_MAGNET_UNKNOWN_STATE'));
        }
        if (magnetState === 'OPEN') {
          setNotification(t('MPLIB_MAGNET_CLOSE_DOOR'));
        }
        if (magnetState === 'CLOSE') {
          setNotification('');
        }
      }
      if (testState === state.FIRST_TEST_COMPLETED) {
        setNotification('');
      }
    }
  }, [testState, magnetState]);
  var testStarted = function testStarted(s) {
    return s === state.FIRST_TEST_COMPLETED || s === state.TEST_COMPLETED;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.testMagnetStep
  }, /*#__PURE__*/React.createElement("section", {
    className: styles.text
  }, t('MPLIB_TESTING_INSTRUCTION_1')), /*#__PURE__*/React.createElement("section", {
    className: styles.text
  }, t('MPLIB_TESTING_INSTRUCTION_2')), /*#__PURE__*/React.createElement("section", {
    className: styles.notification,
    id: "notification"
  }, notification), /*#__PURE__*/React.createElement("section", {
    className: styles.stepSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, "1"), /*#__PURE__*/React.createElement("div", {
    className: styles.instruction
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, t('MPLIB_OPEN_WINDOW')), testStarted(testState) && /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t('MPLIB_IT_WORKED')))), /*#__PURE__*/React.createElement("section", null, testStarted(testState) && /*#__PURE__*/React.createElement(Icon, {
    dataTestId: "firstTestOk",
    className: styles.checkmark,
    icon: "icon-checkmark",
    size: "medium",
    color: colors.green
  }))), /*#__PURE__*/React.createElement("section", {
    className: styles.stepSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.badge, testState === state.NOT_STARTED && styles.disabled)
  }, "2"), /*#__PURE__*/React.createElement("div", {
    className: styles.instruction
  }, /*#__PURE__*/React.createElement("h2", {
    className: classNames('title', testState === state.NOT_STARTED && 'secondary')
  }, t('MPLIB_CLOSE_WINDOW')), testState === state.TEST_COMPLETED && /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t('MPLIB_IT_WORKED')))), /*#__PURE__*/React.createElement("section", null, testState === state.TEST_COMPLETED && /*#__PURE__*/React.createElement(Icon, {
    dataTestId: "secondTestOk",
    className: styles.checkmark,
    icon: "icon-checkmark",
    size: "medium",
    color: colors.green
  }))));
};
TestMagnetComponent.propTypes = {
  giid: PropTypes.string.isRequired,
  deviceLabel: PropTypes.string.isRequired,
  onMagnetStateChanged: PropTypes.func,
  onTestStateChanged: PropTypes.func,
  client: PropTypes.shape({
    query: PropTypes.func.isRequired,
    mutate: PropTypes.func.isRequired
  }).isRequired,
  intervalInMillis: PropTypes.number,
  useTestMagnetFunc: PropTypes.func
};
TestMagnetComponent.defaultProps = {
  onMagnetStateChanged: function onMagnetStateChanged() {},
  onTestStateChanged: function onTestStateChanged() {},
  intervalInMillis: 3000,
  useTestMagnetFunc: useTestMagnet
};

export { TestMagnetComponent as default };
